import { render, staticRenderFns } from "./ViewOrderProduct.vue?vue&type=template&id=43a36a4f"
import script from "./ViewOrderProduct.vue?vue&type=script&lang=js"
export * from "./ViewOrderProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports